import Element from "../../../components/base/element";
import { BlockTabs, Tabs } from "../../../components/base/block-tabs";
import initListbox from "../../../components/base/forms/collapsible-listbox";

class TabsTechnologies extends Tabs {
    constructor(props) {
        super(props);
    }

    findActive() {
        return Array.from(this.$tabItems).find(($tab) => $tab.closest('.controls-tabs_btn').classList.contains('-active'));
    }

    findTabById(id) {
        return Array.from(this.$tabItems).find(($tab) => $tab.dataset.id === id);
    }

    setActiveById(id) {
        const $tab = this.findTabById(id);

        if ($tab) {
            this.setActiveTab($tab);
        }
    }

    setActiveTab($tab) {
        if (this.$activeTab) {
            this.deactivateTab(this.$activeTab);
        }

        const $wrapper = $tab.closest('.controls-tabs_btn');
        $wrapper.classList.add('-active');
        this.$activeTab = $tab;
        this.dispatchEvent(this.TAB_SWITCH_EVENT, $tab.dataset.id);
    }

    deactivateTab($tab) {
        const $wrapper = $tab.closest('.controls-tabs_btn');
        $wrapper.classList.remove('-active');
    }
}

class TabSelect extends Element {
    constructor(props) {
        super(props);

        this.value = null;
        this.TAB_SWITCH_EVENT = 'tabSwitch';

        this.init();
    }

    init() {
        if (!this.$root || !this.$root.dataset || this.$root.dataset.tabs !== 'tab-select') {
            throw new Error('Tab Select: Root element is not defined.');
        }

        this.listboxController = initListbox(this.$root);

        super.init();
    }

    addEventListeners() {
        this.listboxController.listbox.$root.addEventListener('select', this.handleSelect.bind(this));
    }

    handleSelect() {
        this.value = this.listboxController.listbox.$root.dataset.selected;
        this.dispatchEvent(this.TAB_SWITCH_EVENT, this.value);
    }

    setActiveById(id) {
        const $option = this.$root.querySelector(`[data-value="${id}"]`);

        if ($option) {
            this.listboxController.listbox.selectOption($option);
        }
    }
}

export default class BlockTabsTechnologies extends BlockTabs {
    constructor(props) {
        super(props);
    }

    initTabsController() {
        if (window.matchMedia('(max-width: 768px)').matches) {
            this.tabsController = new TabSelect({ $root: this.$root.querySelector('[data-tabs="tab-select"]') });
        } else {
            this.tabsController = new TabsTechnologies({ $root: this.$root.querySelector('[data-tabs="tab-list"]') });
        }
    }
}